import {
  SHOW_MODAL, HIDE_MODAL
} from '../actions/ModalAction'

const initialState = {
  modalType: null,
  modalProps: {isModalOpen:false}
}

const modal = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalProps: Object.assign(action.modalProps,{isModalOpen:true})
      }
    case HIDE_MODAL:
      return initialState
    default:
      return state
  }
}

export default modal;



// WEBPACK FOOTER //
// ./src/reducers/modal.js